const events = {
  CHANGE: 'range_change',
  DISABLE: 'range_disable',
  ENABLE: 'range_enable',
  RESET: 'range_reset',
};

export default events;



// WEBPACK FOOTER //
// ./resources/assets/js/specifics/filters/userLocation/range/events.js